// Once, this was a util to disable the browser scrollbar without hiding it, or
// to detect it's not present and do nothing. Unfortunately, there is no way to
// do this that doesn't break something else, like window resizing. Now this
// just does the minimum to prevent unwanted scrolling when modals are up.

// References (not really current anymore):
// http://stackoverflow.com/questions/8701754/just-disable-scroll-not-hide-it
// http://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily

let disabled = false;
let totalDisables = 0;

// From second SO link. left: 37, up: 38, right: 39, down: 40, spacebar: 32,
// pageup: 33, pagedown: 34, end: 35, home: 36
const scrollKeys = {38: 1, 40: 1, 33: 1, 34: 1};

//TODO: Left and right have been temporarily removed so they can still be used to
//move in inputs on modals. If they're causing an issue with being used to scroll
//behind a modal, we should deal with that.
//left: 37, right: 39,

const preventDefaultFunc = function(e) {
	e.preventDefault();
};

const preventDefaultForScrollKeysFunc = function(e) {
	if (scrollKeys[e.keyCode]) {
		e.preventDefault();
	}
};

// reallyX are internal helper functions that actually do the scroll mangling.
// The exposed functions count the number of disables/enables and call these
// at the appropriate times.

const reallyDisable = function() {
	disabled = true;
	if (!global.document || !global.window) {
		return;
	}
	document.body.addEventListener("touchmove", preventDefaultFunc, {
		passive: false,
	});
	window.addEventListener("wheel", preventDefaultFunc);
	window.addEventListener("keydown", preventDefaultForScrollKeysFunc);
};

const reallyEnable = function() {
	disabled = false;
	if (!global.document || !global.window) {
		return;
	}
	document.body.removeEventListener("touchmove", preventDefaultFunc, {
		passive: false,
	});
	window.removeEventListener("wheel", preventDefaultFunc);
	window.removeEventListener("keydown", preventDefaultForScrollKeysFunc);
};

const disable = function() {
	totalDisables += 1;
	if (!disabled) {
		reallyDisable();
	}
};

const enable = function() {
	totalDisables -= 1;
	if (totalDisables <= 0 && disabled) {
		reallyEnable();
	}
};

module.exports = {
	disable,
	enable,
	isDisabled: () => disabled,
};
